import Component from 'D:/zxl/workspace/saveWorkSpace/nongtou-uni/components/v-form.vue'
wx.createComponent(Component)